<div mat-dialog-title class="w-[100%]">
  <div class="w-[80%]">
    <h1>Diagnosis Event HCC Details</h1>
  </div>
  <div class="w-[20%] flex justify-end">
    <button (click)="handleClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div mat-dialog-content>
  <div class="hcc-info flex items-center gap-2 px-2">
    <span class="mor-dialog-label">HCC:</span>
    <p [title]="data.hccDescription" class="truncate">
      {{ data.hcc }},
      {{data.hccDescription}}
    </p>

  </div>
  <div class="break my-5"></div>
  <div>
    <table class="w-full text-sm text-left border-collapse">
      <thead>
        <tr class="border-b border-gray-200">
          <th class="mor-dialog-label px-2 py-1 text-gray-700">File Type</th>
          <th class="mor-dialog-label px-2 py-1 text-gray-700">File Name</th>
          <th class="mor-dialog-label px-2 py-1 text-gray-700">Processed Date</th>
        </tr>
      </thead>
      <tbody>
        @if (data.fileList[0].FileType) {
          @for (file of data.fileList; track file) {
          <tr class="border-b border-gray-200">
            <td class="px-2 py-1">{{file.FileType}}</td>
            <td class="px-2 py-1" [title]="file.FileName">
              {{
                file.FileName.length > 20 
                ? (file.FileName | slice:0:20) + '...' 
                : file.FileName
              }}
            </td>
            <td class="px-2 py-1">{{transformDate(file.ProcessedDate)}}</td>
          </tr>
          }
        } @else {
        <tr class="border-b border-gray-200">
          <td class="px-2 py-2 text-center text-gray-500 italic" colspan="3">
            No Files
          </td>
        </tr>
        }
      </tbody>

    </table>
  </div>
</div>